__turbopack_context__.v({
  "container": "Video-module-scss-module__eyp9Aa__container",
  "controls-container": "Video-module-scss-module__eyp9Aa__controls-container",
  "video": "Video-module-scss-module__eyp9Aa__video",
});
